import { render, staticRenderFns } from "./PagesSlider.vue?vue&type=template&id=1a29b445&scoped=true"
import script from "./PagesSlider.vue?vue&type=script&lang=js"
export * from "./PagesSlider.vue?vue&type=script&lang=js"
import style0 from "./PagesSlider.vue?vue&type=style&index=0&id=1a29b445&prod&lang=scss&scoped=true"
import style1 from "./PagesSlider.vue?vue&type=style&index=1&id=1a29b445&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a29b445",
  null
  
)

export default component.exports